import { useMemo } from "react";
import { getColorFromCssVariable } from "ui";
import { LineChartCard } from "./shared/LineChartCard";
import { useDatadogQuery } from "../DatadogAnalytics/useDatadogQuery";

type ConversionRateData = {
  value: number;
  label: string;
}[];

export function IntentConversionRateChart() {
  const { ref, queryStatus, data, error, refetch } =
    useDatadogQuery<ConversionRateData>({
      chartType: "INTENT_CONVERSION_RATE",
    });

  const { labels, conversionRateData } = useMemo(() => {
    if (!Array.isArray(data) || data.length === 0)
      return { labels: [], conversionRateData: [] };

    return {
      labels: data.map((item) => item.label),
      conversionRateData: data.map((item) => item.value),
    };
  }, [data]);

  const color = useMemo(
    () => getColorFromCssVariable("--chart-categorical-2-subtle"),
    []
  );

  return (
    <LineChartCard
      ref={ref}
      title="Intent conversion rate"
      description="Share of intents that resulted in at least one transaction. Measures how many created intents progress to a payment."
      format="percentage"
      labels={labels}
      queryStatus={queryStatus}
      error={error}
      retry={refetch}
      datasets={[
        {
          label: "Conversion rate",
          data: conversionRateData,
          backgroundColor: color,
          borderColor: color,
        },
      ]}
    />
  );
}
